import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const { refreshUser } = useAuth();

  useEffect(() => {
    // Token is set as httpOnly cookie by backend during OAuth callback
    // Small delay to ensure cookie is available before API call
    const timer = setTimeout(async () => {
      try {
        await refreshUser();
        navigate('/dashboard');
      } catch (error) {
        console.error('[AUTH CALLBACK] refreshUser() failed:', error);
        navigate('/login');
      }
    }, 100); // 100ms delay to ensure cookie er synkronisert

    return () => clearTimeout(timer);
  }, [navigate, refreshUser]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gradient-to-br from-[#667eea] to-[#764ba2]">
      <Loader2 className="mb-4 h-14 w-14 animate-spin text-white" />
      <h1 className="text-lg font-medium text-white">Logger inn...</h1>
    </div>
  );
};

export default AuthCallback;
